<template>
    <div class="selected-event-page-component-container">
        <div class="component-wrapper">
            <div class="selected-event-content-container">
                <div class="reschedule-training-text-container">
                    <p>{{ $t('reschedule_training') }}</p>
                </div>

                <div class="selected-event-container" :class="[{'cancelled-event': selectedEvent.Cancelled}]">
                    <div class="event-info-container" >
                        <div class="event-info-text-container day-name-container">
                            <p :class="$store.requestSource.includes('webView') ? 'center-text-with-vag-font' : ''">{{ $t(getDayMonthAndWeekday(selectedEvent.Start_DateTime).dayName) }}</p>
                        </div>
                        <div class="event-info-text-container date-container">
                            <p :class="$store.requestSource.includes('webView') ? 'center-text-with-vag-font' : ''">{{ getDayMonthAndWeekday(selectedEvent.Start_DateTime).dayNumber }} {{ $t(getDayMonthAndWeekday(selectedEvent.Start_DateTime).monthName) }}</p>
                        </div>
                        <div class="event-info-text-container time-container">
                            <p :class="$store.requestSource.includes('webView') ? 'center-text-with-vag-font' : ''">{{ extractTimeFromDate(selectedEvent.Start_DateTime) }}</p>
                        </div>
                        <div v-if="selectedEvent.Cancelled" class="strike-line-cancelled-event"></div>
                    </div>
                </div>
            </div>

            <div class="calendar-container">
                <div class="week-number-and-btns-container">
                    <div class="week-btn-container prev-week-btn-container" :class="disablePrevWeekBtn ? 'disabled-week-btn' : ''" @click="showPrevWeek">
                        <div class="week-btn">
                            <img src="../../assets/icons/circled_back_arrow.png" alt="Back arrow">
                        </div>
                    </div>

                    <div class="week-number-container">
                        <p> {{ $t('week') }} {{ weeksRangeOfSelectedDate[currentDisplayedWeekIndex].weekNumber }}</p>
                    </div>

                    <div class="week-btn-container next-week-btn-container" :class="disableNextWeekBtn ? 'disabled-week-btn' : ''" @click="showNextWeek">
                        <div class="week-btn">
                            <img src="../../assets/icons/circled_forword_arrow.png" alt="Back arrow">
                        </div>
                    </div>
                </div>

                <div class="week-days-container">
                    <ul class="week-days-list">
                        <li class="day-item-container" v-for="(dayObj, index) in weeksRangeOfSelectedDate[currentDisplayedWeekIndex].dates" :key="index">
                            <!-- {{ dayObj }} -->
                            <!-- {{ availabeTimeSlots[index].date ? availabeTimeSlots[index].date : '' }} -->
                            <div class="day-item" @click="isDateAvailable(dayObj.date) ? showSelectedDayTimeSlots(index) : ''" 
                                :class="{
                                    'current-event-day': eventsByDate[dayObj.date] && selectedEvent.Start_DateTime.startsWith(dayObj.date),
                                    'event-day-another-week' : eventsByDate[dayObj.date] && !selectedEvent.Start_DateTime.startsWith(dayObj.date),
                                    'selected-day-item' : selectedDayIndex == index && currentDisplayedWeekIndex == weekIndexOfSelectedDay,
                                    'not-available-date' : (!isDateAvailable(dayObj.date) && !eventsByDate[dayObj.date]) || availabeTimeSlots.length == 0 || !isDateAvailable(dayObj.date),
                                }"
                            >
                                <div class="month-name-container" :class="$store.requestSource.includes('webView') ? 'center-text-with-vag-font' : ''">
                                    <p>{{ $t(getDayMonthAndWeekday(dayObj.date).monthName) }}</p>
                                </div>
                                <div class="day-number-container" :class="$store.requestSource.includes('webView') ? 'center-text-with-vag-font' : ''">
                                    <p>{{ getDayMonthAndWeekday(dayObj.date).dayNumber }}</p>
                                </div>
                                <div class="day-name-container" :class="$store.requestSource.includes('webView') ? 'center-text-with-vag-font' : ''">
                                    <p>{{ $t(getDayMonthAndWeekday(dayObj.date).dayName) }}</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <TimeSlotsComponent v-if="selectedDay" :selectedDayTimeSlots="selectedDayTimeSlots" :updateRescheduleEventDataObject="updateRescheduleEventDataObject"
                :extractTimeFromDate="extractTimeFromDate" :selectedEvent="selectedEvent"
                :toggoleDisplayingSaveBtnHandle="toggoleDisplayingSaveBtnHandle" :clientEventsObj="clientEventsObj"
                :updateSelectedDayTimeSlots="updateSelectedDayTimeSlots" :filtersOptions="filtersOptions" :updateFilterOptions="updateFilterOptions"
            />

            <!-- :toggleNoAvailableTimeSlotsFounded="toggleNoAvailableTimeSlotsFounded" :noAvailableTimeSlotsFounded="noAvailableTimeSlotsFounded" -->

            <div v-if="showSaveBtn" class="save-btn-container">
                <div class="save-btn" @click="showPopupMsgHandle()">
                    <p :class="$store.requestSource.includes('webView') ? 'center-text-with-vag-font' : ''">{{ $t('save') }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TimeSlotsComponent from './TimeSlotsComponent.vue';
export default {
    name: "SelectedEventPage",
    props: {
        clientEventsObj: Object,
        allClientEvents: Array,
        availabeTimeSlots: Array,
        selectedEvent: Object,
        extractTimeFromDate: Function,
        // getDayName: Function,
        // getDayAndMonthAbbreviation: Function,
        getDayMonthAndWeekday: Function,
        weeksRangeOfSelectedDate: Array,
        toggoleDisplayingSaveBtnHandle: Function,
        showSaveBtn: Boolean,
        updatePopupMsgObj: Function,
        rescheduleEvent: Function,
        rescheduleEventData: Object,
        updateRescheduleEventDataObject: Function,
    },
    components: {
        TimeSlotsComponent,
    },
    data() {
        return {
            currentDisplayedWeekIndex: 0,
            weekIndexOfSelectedDay: null,
            selectedDayIndex: null,
            selectedDay: false,
            selectedDayTimeSlots: null,
            rescheduleEventActive: false,
            // rescheduleEventData: null,
            disablePrevWeekBtn: true,
            disableNextWeekBtn: false,
            // noAvailableTimeSlotsFounded: false,
            filtersOptions: [
                {
                    name: "time",
                    active: false,
                    options: {
                        morning: false,
                        afternoon: false,
                        evening: false,
                    }
                },
                // {
                //     name: "trainer_gender",
                //     active: false,
                //     options: {
                //         "Male trainer": false,
                //         "Female trainer": false,
                //     }
                // },
                // {
                //     name: "subscroption_type",
                //     active: false,
                //     options: {
                //         flex: false,
                //         duo: false,
                //         solo: false,
                //     }
                // },
            ],
        }
    },
    methods: {
        showPrevWeek: function () {
            if (this.currentDisplayedWeekIndex > 0) {
                this.currentDisplayedWeekIndex--;
            }

            if (this.currentDisplayedWeekIndex === 0) {
                this.disablePrevWeekBtn = true;
                this.disableNextWeekBtn = false;
            } else {
                this.disablePrevWeekBtn = false;
                this.disableNextWeekBtn = false;
            }

        },
        showNextWeek: function () {
            // console.log(this.weeksRangeOfSelectedDate);
            if (this.currentDisplayedWeekIndex < this.weeksRangeOfSelectedDate.length - 1) {
                this.currentDisplayedWeekIndex++;
            }

            if (this.currentDisplayedWeekIndex === this.weeksRangeOfSelectedDate.length - 1) {
                this.disableNextWeekBtn = true;
                this.disablePrevWeekBtn = false;
            } else {
                this.disableNextWeekBtn = false;
                this.disablePrevWeekBtn = false;
            }
        },
        showAvailableTimeSlotsComponent: function () {
            this.rescheduleEventActive = true;
        },
        // toggleNoAvailableTimeSlotsFounded: function (newStatus) {
        //     this.noAvailableTimeSlotsFounded = newStatus;
        // },
        showSelectedDayTimeSlots: function (selectedDayIndex) {
            // console.log(selectedDayIndex);
            this.selectedDayTimeSlots = null;
            // this.noAvailableTimeSlotsFounded = false;
            this.selectedDayIndex = selectedDayIndex;
            this.weekIndexOfSelectedDay = this.currentDisplayedWeekIndex;
            this.selectedDay = true;
            // console.log(this.availabeTimeSlots[selectedDayIndex].availableSlots);
            // console.log(this.availabeTimeSlots[selectedDayIndex].date);
            // console.log((this.availabeTimeSlots[0].date).slice(0, 10));
            // console.log(this.weeksRangeOfSelectedDate[this.currentDisplayedWeekIndex].dates[selectedDayIndex].date);

            // const noAvailableTimeSlots = Object.values(this.availabeTimeSlots[selectedDayIndex].availableSlots).every(arr => arr.length === 0);
            // console.log(noAvailableTimeSlots);


            // console.log(this.availabeTimeSlots);
            // console.log(this.availabeTimeSlots[selectedDayIndex].availableSlots);


            this.availabeTimeSlots.forEach((dayObj) => {
                const selectedDate = (dayObj.date).slice(0, 10);
                if (selectedDate === this.weeksRangeOfSelectedDate[this.currentDisplayedWeekIndex].dates[selectedDayIndex].date) {
                    // console.log(selectedDate);
                    // console.log(dayObj);
                    const noAvailableTimeSlots = Object.values(dayObj.availableSlots).every(arr => arr.length === 0);
                    // console.log(noAvailableTimeSlots);

                    if (!noAvailableTimeSlots) {
                        this.selectedDayTimeSlots = dayObj.availableSlots;
                        // this.selectedDayTimeSlots = null;
                    }
                }
            });

            // console.log(this.selectedDayTimeSlots);
        },
        updateSelectedDayTimeSlots: function (newSelectedDayTimeSlots) {
            this.selectedDayTimeSlots = newSelectedDayTimeSlots;
        },
        isDateAvailable: function (dateStr) {
            // console.log("dateStr: " + dateStr);
            // console.log(this.availabeTimeSlots);
            return this.availabeTimeSlots.some(slot => slot.date.startsWith(dateStr));
        },
        updateFilterOptions: function(newFilterOptionObj, filterOptionsIndex) {
            this.filtersOptions[filterOptionsIndex] = newFilterOptionObj;
        },
        // updateRescheduleEventDataObjectHandle: function (newObjData) {
        //     this.updateRescheduleEventDataObject(newObjData);
        //     // console.log(this.rescheduleEventData);
        // },
        showPopupMsgHandle: function () {
            let popupObj;
            // console.log("this.rescheduleEventData:");
            // console.log(this.rescheduleEventData);
            // console.log(this.clientEventsObj);
            // console.log(this.clientEventsObj.partnerData.events);
            let text = 'confirm_training_reschedule';
            let activePartnerEvent = false;
            let partnerEvent;
            // let selectedPartnerEventId = null;
            if (this.clientEventsObj.partnerData) {
                partnerEvent = this.clientEventsObj.partnerData.events.find((partnerEvent) => partnerEvent.id == this.rescheduleEventData.partnerEventId);
                // console.log(partnerEvent);
                if (partnerEvent) {
                    // selectedPartnerEventId = partnerEvent.id;
                    activePartnerEvent = !partnerEvent.Rescheduled && !partnerEvent.Cancelled;
                    text = partnerEvent.Cancelled ? 'duo_confirm_training_reschedule' : text;
                }
            }

            // console.log("partnerEvent: ");
            // console.log(partnerEvent);

            let reactivateClientCancelledEvent = false;
            let rescheduleEventDataForReactivateCancelledEvent = this.rescheduleEventData;
            // console.log("Default value of rescheduleEventData:");
            // console.log(this.rescheduleEventData);
            // console.log("Default value of rescheduleEventDataForReactivateCancelledEvent:");
            // console.log(rescheduleEventDataForReactivateCancelledEvent);



            if (partnerEvent && activePartnerEvent && this.selectedEvent.Cancelled && this.selectedEvent.Start_DateTime === this.rescheduleEventData.newStartDateTime) {
                reactivateClientCancelledEvent = true;
                text = 'confirm_reactivate_cancelled_time_slot';
                rescheduleEventDataForReactivateCancelledEvent.reactivateClientCancelledEvent = true;
            }
            else {
                if (reactivateClientCancelledEvent) {
                    // console.log("reactivateClientCancelledEvent is true...");
                    // console.log("this.rescheduleEventData when reactivateClientCancelledEvent is true:");
                    // console.log(this.rescheduleEventData);
                    popupObj = {
                        popupType: 'confirm',
                        title: 'confirm_reactivation',
                        text: text,
                        actionBtn: () => this.rescheduleEvent(rescheduleEventDataForReactivateCancelledEvent),
                        // actionBtn: () => console.log(rescheduleEventDataForReactivateCancelledEvent),
                        // activePartnerEvent: activePartnerEvent,
                        // partnerEvent: partnerEvent,
                        // clientName: this.clientEventsObj.clientName,
                        // partnerName: this.clientEventsObj.partnerData ? this.clientEventsObj.partnerData.name : null,
                        // partnerEventId: partnerEvent ? partnerEvent.id : null,
                    };
                }
                else {
                    // console.log("this.clientEventsObj:");
                    // console.log(this.clientEventsObj);

                    popupObj = {
                        popupType: 'confirm',
                        title: 'confirm_reschedule',
                        text: text,
                        actionBtn: () => this.rescheduleEvent(this.rescheduleEventData),
                        activePartnerEvent: activePartnerEvent,
                        partnerEvent: partnerEvent,
                        clientName: (this.selectedEvent.Cancelled && (partnerEvent && partnerEvent.Cancelled) || (!this.selectedEvent.Cancelled && partnerEvent && partnerEvent.Cancelled)) ? this.clientEventsObj.clientName : null,
                        partnerName: ((this.selectedEvent.Cancelled && partnerEvent && partnerEvent.Cancelled && this.clientEventsObj.partnerData) || (!this.selectedEvent.Cancelled && partnerEvent && partnerEvent.Cancelled && this.clientEventsObj.partnerData)) ? this.clientEventsObj.partnerData.name : null,
                        partnerEventId: partnerEvent ? partnerEvent.id : null,
                    };
                }
            }

            // console.log(popupObj);
            this.updatePopupMsgObj(popupObj);
        },
        // resetSelectedTimeSlot: function() {
        //     this.updateRescheduleEventDataObject(null);
        //     this.toggoleDisplayingSaveBtnHandle(false);
        // }
    },
    computed: {
        // Get the events that have the same date with the displayed calender week.
        eventsByDate() {
            const eventsMap = {};
            this.allClientEvents.forEach(event => {
                const date = event.Start_DateTime.slice(0, 10);
                eventsMap[date] = event;
            });
            return eventsMap;
        }
    },
    created() {
        // console.log("SelectedeventPage...");
        // console.log(this.weeksRangeOfSelectedDate[1].dates)
        // Select the week index of the selected event based on its date.
        const selectedEventDate = this.selectedEvent.Start_DateTime;

        // Extract only the date part in "YYYY-MM-DD" format
        const targetDate = new Date(selectedEventDate).toISOString().split('T')[0];

        // console.log(this.weeksRangeOfSelectedDate);

        const index = this.weeksRangeOfSelectedDate.findIndex(week =>
            week.dates.some(d => d.date === targetDate)
        );

        this.currentDisplayedWeekIndex = index;

        // Check if the current displayed week is the first or last week in the range
        if (this.currentDisplayedWeekIndex === 0) {
            this.disablePrevWeekBtn = true;
            this.disableNextWeekBtn = false;
        } else if (this.currentDisplayedWeekIndex === this.weeksRangeOfSelectedDate.length - 1) {
            this.disableNextWeekBtn = true;
            this.disablePrevWeekBtn = false;
        } else {
            this.disablePrevWeekBtn = false;
            this.disableNextWeekBtn = false;
        }
    },
}
</script>

<style>
.selected-event-page-component-container {
    position: relative;
    flex: 1;
    width: 100%;
    max-width: 700px;
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    align-items: center;
    padding-bottom: 15px;
    /* border: 1px solid red; */
}

.selected-event-page-component-container .component-wrapper {
    width: 95%;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    max-height: 95%;
    padding: 0 5px;
    /* border: 1px solid blue; */
}

.selected-event-page-component-container .selected-event-content-container {
    width: 90%;
    display: flex;
    flex-direction: column;
    margin-bottom: 28px;
    /* border: 1px solid blue; */
}

.selected-event-page-component-container .reschedule-training-text-container {
    width: 100%;
    display: flex;
    justify-content: center;
    padding-bottom: 10px;
}

.selected-event-page-component-container .reschedule-training-text-container p {
    font-size: 24px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #616365;
    /* line-height: 35px; */
}

.selected-event-page-component-container .selected-event-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid #92d400;
    border-radius: 10px;
}

.selected-event-page-component-container .cancelled-event {
    border: 1px solid #E6E8E8;
}

.selected-event-page-component-container .event-info-container {
    position: relative;
    width: 90%;
    display: flex;
    justify-content: space-between;
    padding: 0 5px 0 15px;
    /* border: 1px solid red; */
}

.selected-event-page-component-container .event-info-text-container p {
    width: 100%;
    font-size: 25px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #616365;
    line-height: 35px;
    /* border: 1px solid; */
}

.selected-event-page-component-container .strike-line-cancelled-event {
    position: absolute;
    width: 100%;
    top: 51%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 1px solid #a0a1a3;
}

.selected-event-page-component-container .calendar-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 20px;
    background: #DDF2FD;
    padding: 10px 10px 20px;
    margin-bottom: 15px;
}

.selected-event-page-component-container .week-number-and-btns-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 20px;
}

.selected-event-page-component-container .week-btn-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    cursor: pointer;
    border-radius: 50%;
    background: #009df4;
    border: 1px solid #ffffff;
    overflow: hidden;
}

.selected-event-page-component-container .disabled-week-btn {
    background: #A0A1A3;
}

.selected-event-page-component-container .week-btn {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.selected-event-page-component-container .week-btn img {
    width: 40%;
    filter: drop-shadow(0px 0px 0px white) drop-shadow(0px 0px 0px white);
    /* border: 1px solid red; */
}

[dir="rtl"] .selected-event-page-component-container .week-btn img {
    transform: rotate(180deg);
}

.selected-event-page-component-container .week-number-and-btns-container p {
    font-size: 24px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #616365;
    /* letter-spacing: -1px; */
}

.selected-event-page-component-container .week-number-container {
    padding: 0 25px;
}

.selected-event-page-component-container .week-days-container {
    width: 100%;
}

.selected-event-page-component-container .week-days-list {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.selected-event-page-component-container .day-item-container {
    width: calc((100% / 7) - 12px);
    /* width: 47px; */
    max-width: 45px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
}

.selected-event-page-component-container .events-warpper, .selected-event-page-component-container .day-item {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.selected-event-page-component-container .day-item {
    align-items: center;
    border: 2px solid #d6d9d9;
    border-radius: 8px;
    padding: 3px 0 6px;
    background: #ffffff;
    /* overflow: hidden; */
}

/* .day-item-clickable {
    cursor: pointer;
} */

.selected-event-page-component-container .current-event-day {
    border: 2px solid #92d400;
}

.selected-event-page-component-container .day-item-container .month-name-container p {
    font-size: 17px;
    font-family: 'VAG Rounded Std', sans-serif;
    /* font-weight: bold; */
    color: #616365;
    line-height: 18px;
    /* border: 1px solid; */
}

.selected-event-page-component-container .day-item-container .day-number-container p {
    font-size: 22px;
    font-family: 'VAG Rounded Std', sans-serif;
    /* font-weight: bold; */
    color: #616365;
    line-height: 20px;
    /* border: 1px solid; */
}

.selected-event-page-component-container .day-item-container .day-name-container p {
    font-size: 17px;
    font-family: 'VAG Rounded Std', sans-serif;
    /* font-weight: bold; */
    color: #616365;
    line-height: 16px;
    /* border: 1px solid; */
}

.selected-event-page-component-container .selected-day-item {
    border: 2px solid #009df4;
    background: #009df4;
}

.selected-event-page-component-container .event-day-another-week {
    border: 2px solid #92d400;
}

.selected-event-page-component-container .not-available-date, .selected-event-page-component-container .event-day-another-week {
    cursor: default;
}

.selected-event-page-component-container .day-item-container .not-available-date p, .selected-event-page-component-container .day-item-container .event-day-another-week p {
    color: #D6D8D8;
}

.selected-event-page-component-container .day-item-container .selected-day-item p {
    color: #ffffff;
}

.selected-event-page-component-container .save-btn-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    /* border: 1px solid red; */
}

.selected-event-page-component-container .save-btn {
    /* width: 50%;
    max-width: 175px; */
    background: #009df4;
    padding: 6px 50px;
    border-radius: 30px;
    cursor: pointer;
}

.selected-event-page-component-container .save-btn p {
    font-size: 24px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #ffffff;
    text-align: center;
    transform: translateY(2px);
}

@media (max-width: 425px) {
    .selected-event-page-component-container .day-item-container {
        /* width: calc((100% / 7) - 10px); */
        min-width: 40px;
    }
}


@media (max-width: 375px) {
    .selected-event-page-component-container .reschedule-training-text-container p {
        font-size: calc(16px + 2vw);
    }

    .selected-event-page-component-container .event-info-text-container p {
        font-size: calc(16px + 2vw);
    }

    .selected-event-page-component-container .week-btn-container {
        width: 35px;
        height: 35px;
    }

    .selected-event-page-component-container .week-btn img {
        width: 35%;
    }

    .selected-event-page-component-container .week-number-container p {
        font-size: calc(16px + 2vw);
    }

    .selected-event-page-component-container .day-item-container {
        /* width: calc((100% / 7) - 6px); */
        min-width: 38px;
    }

    .selected-event-page-component-container .day-item-container .month-name-container p {
        font-size: 14px;
    }

    .selected-event-page-component-container .day-item-container .day-number-container p {
        font-size: 20px;
    }

    .selected-event-page-component-container .day-item-container .day-name-container p {
        font-size: 14px;
    }

    .selected-event-page-component-container .save-btn {
        padding: 6px 45px;
    }

    .selected-event-page-component-container .save-btn p {
        font-size: 20px;
    }
}

@media (max-width: 320px) {
    .selected-event-page-component-container .reschedule-training-text-container p {
        font-size: calc(14px + 2vw);
    }

    .selected-event-page-component-container .day-item-container {
        min-width: 35px;
    }

    .selected-event-page-component-container .save-btn {
        padding: 6px 40px;
    }

    .selected-event-page-component-container .save-btn p {
        font-size: 18px;
    }
}
</style>